import { clsx } from "clsx";
import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger";
  size?: "md" | "lg";
  fullWidth?: boolean;
}

export function BigButton({
  variant = "primary",
  size = "lg",
  fullWidth = false,
  className,
  children,
  disabled,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      disabled={disabled}
      className={clsx(
        "inline-flex items-center justify-center font-semibold rounded-[var(--kiosk-brand-radius)] transition-opacity select-none",
        size === "lg" && "text-2xl px-10 py-6 min-h-[80px]",
        size === "md" && "text-xl px-8 py-4 min-h-[64px]",
        fullWidth && "w-full",
        variant === "primary" &&
          "bg-[var(--kiosk-brand-accent)] text-white hover:opacity-90 active:opacity-80",
        variant === "secondary" &&
          "bg-[var(--kiosk-brand-surface)] text-[var(--kiosk-brand-text)] border-2 border-[var(--kiosk-brand-primary)] hover:opacity-90 active:opacity-80",
        variant === "danger" &&
          "bg-red-600 text-white hover:opacity-90 active:opacity-80",
        disabled && "opacity-40 pointer-events-none",
        className,
      )}
      aria-disabled={disabled}
    >
      {children}
    </button>
  );
}
